import { TenantClient } from "./tenant-provider";

const tenantClient = new TenantClient();

export default tenantClient;
